<mat-chip-set>
	<mat-chip-option
		[selectable]="false"
		[selected]="selectedFilter()"
		[matMenuTriggerFor]="filterChipMenu"
		><div class="filter-chip">
			@if (selectedFilter()) {
				{{ selectedFilter() | translate }}
				<mat-icon (click)="setFilter(null, $event)" [svgIcon]="'close'" />
			} @else {
				{{ title() | translate }}
				<mat-icon [svgIcon]="'down-dropdown-arrow'" />
			}
		</div>
	</mat-chip-option>
</mat-chip-set>

<mat-menu #filterChipMenu="matMenu">
	@for (filter of filterOptions(); track filter.value) {
		<button class="document-type" mat-menu-item (click)="setFilter(filter.value, null)">
			<mat-icon [ngClass]="filter.icon" [svgIcon]="filter.icon"></mat-icon
			>{{ filter.value | translate }}
		</button>
	}
</mat-menu>
